<script>
import { Sprite, Container, BLEND_MODES } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene18',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene18 = this.$scene

    const container = new Container()
          container.alpha = 0
    // this.setCenterContainer(container)   
    this.$scene.addChild(container)

    const bkg_container = new Container()
    const zoom_container = new Container()

    this.setCenterContainer(bkg_container)
    this.setCenterContainer(zoom_container)

    container.addChild(bkg_container)
    container.addChild(zoom_container)

    const sub1 = new TimelineMax()
    const sub2 = new TimelineMax()


    // ******************************************************** //
    // ******************************************************** //

    let outro1 = (this.$root.above('tablet')) 
        ? { ref: 'outro1', container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*2, y: -360 }
        : { ref: 'outro1_half', container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale_optimize*2, y: -360 }
    let parlement = { ref: 'parlement', container: zoom_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*7.48, y: 1900, x:-4 }
    let ailes = { ref: 'ailes', container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*7.48, y: 1900, x:-4 }

    const els = { 
      'bg': { container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'sky': { container: zoom_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*20.2, y: -50, x:-28 },
      'clouds': { container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*20.2, y: 200, x: -28 },
      'outro1': outro1,  
      'clock': { container: zoom_container, alpha: 1, position: { x: 0, y: -32, width: 1536, height: 2160 }, scale: this.$root.$scale*2 }, 
      'ailes': ailes,
      'parlement': parlement,
      'front': { container: zoom_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*20.2, y: 1560, x:-28 },
      'border': { container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*20.2, y: 3560, x:-28 },
      'flag1': { container: zoom_container, alpha: 1, scale: this.$root.$scale*20.2, y: -2970, x: 214 },
      'flag2': { container: zoom_container, alpha: 0, scale: this.$root.$scale*20.2, y: -2970, x: 214 },
      'flag3': { container: zoom_container, alpha: 0, scale: this.$root.$scale*20.2, y: -2970, x: 214 },
    }

    const optimize = false

    _.each(els, (el, name)=>{
      const _name = (el.ref) ? el.ref : name
      // const sprite = new Sprite.from(this.$resources[_name].texture) 
      const sprite = (!optimize) ? new Sprite.from(this.$resources[_name].texture) : new Sprite.from(texture)
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]

    const tempo = 1
    const appear = 15

    let flag_motion = new TimelineMax({ repeat: -1 })
        .add([
            TweenMax.to(sprites['flag2'], .35, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
            TweenMax.to(sprites['flag1'], .35, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        ])
        .add([
            TweenMax.to(sprites['flag3'], .35, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
            TweenMax.to(sprites['flag2'], .35, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        ])
        .add([
            TweenMax.to(sprites['flag1'], .35, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
            TweenMax.to(sprites['flag3'], .35, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        ])

    TweenMax.set(sprites['ailes'], { pixi:{ blur: 10 } })

    sub1
      .add([
        // TweenMax.to(alphaFilter, 0.1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } }),
        TweenMax.to(container, 0.1, { alpha: 1, ease: Linear.easeNone }),
        TweenMax.to(sprites['parlement'], appear*0.04, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: 5 }),
        TweenMax.to(sprites['sky'], appear*0.02, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: 3 }),
        TweenMax.to(sprites['outro1'], appear*0.04, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 6 }),
        TweenMax.to(sprites['clock'], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 6 }),
        TweenMax.to(sprites['front'], appear*0.02, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: 7 }),
        TweenMax.to(sprites['clouds'], appear*0.30, { pixi:{ x: 4000 }, ease: Linear.easeNone, delay: appear*0.62 }),
        TweenMax.to(sprites['border'], appear*0.30, { pixi:{ y: 1560 }, ease: Linear.easeNone, delay: appear*0.61 }),
        TweenMax.to(sprites['ailes'], appear*0.02, { pixi:{ blur: 0 }, ease: Linear.easeNone, delay: 7.5 }),
      ])

    sub2
      .to(zoom_container, appear*0.9, { pixi:{ scale: 0.051, y: '-=85', x: '+=1.5' }, ease: Cubic.easeOut })

    this.$tl.add([ sub1, sub2 ], 34)

  },
  mounted() {

    // console.log('Scene18');
    // this.$parent.chapter.$tl.seek(34)
    
  }
}
</script>























